import { render, staticRenderFns } from "./Activation.vue?vue&type=template&id=f15819b4&scoped=true"
import script from "./Activation.vue?vue&type=script&lang=js"
export * from "./Activation.vue?vue&type=script&lang=js"
import style0 from "./Activation.vue?vue&type=style&index=0&id=f15819b4&prod&lang=css"
import style1 from "./Activation.vue?vue&type=style&index=1&id=f15819b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15819b4",
  null
  
)

export default component.exports